"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectGrid = void 0;
const react_1 = __importStar(require("react"));
const components_1 = require("@veeam/components");
const utils_1 = require("../../helpers/utils");
const components_2 = require("./components");
require("./types");
function SelectGrid({ renderAvailableContent, renderChosenContent, availableData, chosenData, idKey, sortChosen = true, displayField, addText, removeText, loading, onAdd, onRemove, searchRenderer, actionsRenderer, rowHeight, cellRenderer, isRowDisabled, subheaderRenderer, cellRendererWithSearch, }) {
    const [dataState, setDataState] = react_1.useState({
        availableData: [],
        selectedAvailableData: [],
        chosenData: [],
        selectedChosenData: [],
    });
    const availableTitle = renderAvailableContent(dataState.availableData.length);
    const chosenTitle = renderChosenContent(dataState.chosenData.length);
    const handleAdd = () => {
        const newChoseGridData = [...dataState.chosenData, ...dataState.selectedAvailableData];
        if (sortChosen) {
            newChoseGridData.sort(utils_1.compareBy(displayField));
        }
        setDataState((prevState) => ({
            availableData: utils_1.filteredCollections(prevState.availableData, newChoseGridData, utils_1.excludeCollectionsByKey(idKey), utils_1.compareBy(displayField)),
            selectedAvailableData: [],
            chosenData: newChoseGridData,
            selectedChosenData: [],
        }));
        onAdd({
            addItems: dataState.selectedAvailableData,
            chosenItems: newChoseGridData,
        });
    };
    const handleRemove = () => {
        const newChoseGridData = utils_1.filteredCollections(dataState.chosenData, dataState.selectedChosenData, utils_1.excludeCollectionsByKey(idKey), sortChosen ? utils_1.compareBy(displayField) : undefined);
        const newAvailableGridData = [...dataState.availableData, ...dataState.selectedChosenData].sort(utils_1.compareBy(displayField));
        setDataState({
            availableData: newAvailableGridData,
            selectedAvailableData: [],
            chosenData: newChoseGridData,
            selectedChosenData: [],
        });
        onRemove({
            removeItems: dataState.selectedChosenData,
            chosenItems: newChoseGridData,
        });
    };
    react_1.useEffect(() => {
        setDataState({
            availableData: utils_1.filteredCollections(availableData, chosenData, utils_1.excludeCollectionsByKey(idKey), utils_1.compareBy(displayField)),
            selectedAvailableData: [],
            chosenData: chosenData,
            selectedChosenData: [],
        });
    }, [availableData, chosenData]);
    return (react_1.default.createElement(components_2.Root, null,
        react_1.default.createElement(components_2.ColumnGrid, { id: "availableGrid", idKey: idKey, title: availableTitle, selected: dataState.selectedAvailableData.map((item) => item[idKey]), data: dataState.availableData, displayField: displayField, onSelect: (selectedItems) => {
                setDataState((prevState) => ({
                    availableData: prevState.availableData,
                    selectedAvailableData: selectedItems,
                    chosenData: prevState.chosenData,
                    selectedChosenData: [],
                }));
            }, onRowDoubleClick: () => {
                handleAdd();
            }, loading: loading, dataState: dataState, setDataState: setDataState, searchRenderer: searchRenderer, actionsRenderer: actionsRenderer, rowHeight: rowHeight, cellRenderer: cellRendererWithSearch !== null && cellRendererWithSearch !== void 0 ? cellRendererWithSearch : cellRenderer, isRowDisabled: isRowDisabled, subheaderRenderer: subheaderRenderer }),
        react_1.default.createElement(components_2.ColumnActions, { withActionsBar: !!searchRenderer },
            react_1.default.createElement(components_1.Button, { ui: components_1.BUTTON_VIEW.primary, disabled: loading || !dataState.selectedAvailableData.length, onClick: () => {
                    handleAdd();
                } }, addText),
            react_1.default.createElement(components_1.Button, { ui: components_1.BUTTON_VIEW.alternate, disabled: loading || !dataState.selectedChosenData.length, onClick: () => {
                    handleRemove();
                } }, removeText)),
        react_1.default.createElement(components_2.ColumnGrid, { id: "choseGrid", idKey: idKey, title: chosenTitle, selected: dataState.selectedChosenData.map((item) => item[idKey]), data: dataState.chosenData, displayField: displayField, onSelect: (selectedItems) => {
                setDataState((prevState) => ({
                    availableData: prevState.availableData,
                    selectedAvailableData: [],
                    chosenData: prevState.chosenData,
                    selectedChosenData: selectedItems,
                }));
            }, onRowDoubleClick: () => {
                handleRemove();
            }, dataState: dataState, setDataState: setDataState, searchRenderer: searchRenderer, actionsRenderer: actionsRenderer, rowHeight: rowHeight, cellRenderer: cellRenderer, isRowDisabled: isRowDisabled, subheaderRenderer: subheaderRenderer })));
}
exports.SelectGrid = SelectGrid;
SelectGrid.displayName = 'SelectGrid';
//# sourceMappingURL=SelectGrid.js.map